<div class="d-flex flex-column align-items-center w-100">
	<h2 class="fs-xl fw-bold lh-xl mb-2">{{ title }}</h2>

	<div [innerHTML]="message" class="text-center fs-lg fw-medium lh-lg mb-8"></div>

	<div class="mt-auto d-flex justify-content-center align-items-center">
		<button (click)="dialogRef.close()" class="btn btn-outlined" type="button">Close</button>
	</div>
</div>
